// MultiDragPreview — 멀티 선택 드래그 시 DragOverlay 내부에 렌더되는 프리뷰 컴포넌트 (U45).
//
// 역할:
//   - "N개 항목" 텍스트 + 카운트 뱃지 표시
//   - 스택 카드 시각 효과 (3겹 offset 배경 카드)
//   - DndProvider의 DragOverlay 안에서만 사용

interface MultiDragPreviewProps {
  /** 드래그 중인 항목 수 */
  count: number;
}

export function MultiDragPreview({ count }: MultiDragPreviewProps) {
  return (
    // 스택 카드 컨테이너 — 상대 위치 기준
    <div className="multi-drag-preview" aria-label={`${count}개 항목 이동 중`}>
      {/* 뒤쪽 스택 카드 — 시각적 깊이 효과 (최대 2장) */}
      {count >= 3 && (
        <div className="multi-drag-preview__stack multi-drag-preview__stack--3" aria-hidden="true" />
      )}
      {count >= 2 && (
        <div className="multi-drag-preview__stack multi-drag-preview__stack--2" aria-hidden="true" />
      )}

      {/* 앞쪽 주 카드 */}
      <div className="multi-drag-preview__card">
        {/* 카운트 뱃지 */}
        <span className="multi-drag-preview__badge" aria-hidden="true">
          {count}
        </span>

        {/* 본문 텍스트 */}
        <span className="multi-drag-preview__label">
          {count}개 항목
        </span>
      </div>
    </div>
  );
}
